<ng-container [ngSwitch]="type">
   <ng-container *ngSwitchCase="dateType">{{ data | date:'dd-MM-yyyy' }}</ng-container>
   <ng-container *ngSwitchCase="datetimeType">{{ data | date:'dd-MM-yyyy HH:mm' }}</ng-container>
   <ng-container *ngSwitchCase="datetimesecondsType">{{ data | date:'dd-MM-yyyy HH:mm:ss' }}</ng-container>
   <ng-container *ngSwitchCase="dateshortType">{{ data | date:'dd-MM' }}</ng-container>
   <ng-container *ngSwitchCase="timeType">{{ data ? (data | date:'HH:mm') : '' }}</ng-container>
   <ng-container *ngSwitchCase="timesecondsType">{{ data | date:'HH:mm:ss' }}</ng-container>
   <ng-container *ngSwitchCase="priceType">{{ data | money }}</ng-container>
   <ng-container *ngSwitchCase="stringAndIDType">
      <span class="label-with-id">
         <span *ngIf="idValue !== null && idValue !== undefined && stringIDdisplay === stringIDdisplayType.displayIdBefore"
            class="label-with-id__id">
            #{{ idValue }}
         </span>
         <span class="label-with-id__label">
            {{ displayContent || data }}
         </span>
         <span *ngIf="idValue !== null && idValue !== undefined && stringIDdisplay === stringIDdisplayType.displayIdAfter"
            class="label-with-id__id">
            (#{{ idValue }})
         </span>
      </span>
   </ng-container>
   <ng-container *ngSwitchDefault>{{ displayContent || data }}</ng-container>
</ng-container>
